// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__tM2tJ","col":"CardReaderDesc_col__2mNjQ","label":"CardReaderDesc_label__11EIn"};